export const services = [
  {
    id: 1,
    icon: 'ri-briefcase-line',
    title: 'Executive Search',
    description: 'Improve workforce alignment and reduce mis-hires with strategic talent acquisition that connects leadership capabilities to measurable business outcomes.',
    link: '/mainframe-solutions',
  },
  {
    id: 2,
    icon: 'ri-code-box-line',
    title: 'Software Development',
    description: 'Modernize operational systems with custom software development. Build tools that streamline workflows and support scalable infrastructure across departments.',
    link: '/mainframe-solutions',
  },
  {
    id: 3,
    icon: 'ri-cpu-line',
    title: 'BuildFit AI',
    description: 'Our proprietary AI-assisted hiring platform that strengthens consistency in candidate evaluation. Structured interviews, role-aligned frameworks, and human-led decision making.',
    link: '/buildfit-ai',
    highlight: true,
  },
  {
    id: 4,
    icon: 'ri-settings-3-line',
    title: 'Operational Systems',
    description: 'Strengthen operational efficiency, reduce repetitive workflows, and build infrastructure that supports scalable growth across departments.',
    link: '/mainframe-solutions',
  },
];

export const buildFitFeatures = [
  {
    id: 1,
    title: 'Structured Video Interviews',
    description: 'Standardized interview protocols that ensure every candidate is evaluated on consistent criteria, reducing bias and improving decision quality.',
  },
  {
    id: 2,
    title: 'Role-Aligned Frameworks',
    description: 'Evaluation criteria defined by hiring managers and aligned to specific position requirements, ensuring relevance and precision in assessment.',
  },
  {
    id: 3,
    title: 'Human Led, AI Assisted',
    description: 'All hiring decisions remain in human hands. AI supports the process by organizing data and surfacing patterns, but never replaces human judgment.',
  },
];

export const speakingEngagements = [
  {
    id: 1,
    year: '2026',
    event: 'Gulf Coast Symposium on HR Issues',
    topic: 'Reducing Hiring Risk Through Structured Evaluation and Responsible AI Use',
    description: 'Session on integrating AI tools into hiring processes while maintaining human oversight, ethical standards, and compliance requirements.',
  },
  {
    id: 2,
    year: '2026',
    event: 'Regional Hispanic Contractors Association (RHCA)',
    topic: 'OSHA Safety & AI Roundtable',
    description: 'Participated in discussions exploring the intersection of workplace safety, responsible AI adoption, and operational leadership across construction and infrastructure environments.',
  },
  {
    id: 3,
    year: '2026',
    event: 'HR Houston Seminar',
    topic: 'Reducing Hiring Risk Through Structured Evaluation and Responsible AI Use',
    description: 'Presented frameworks for systematic candidate assessment and the role of structured interviews in mitigating hiring risk across organizations.',
  },
  {
    id: 4,
    year: '2026',
    event: 'Voyage Houston',
    topic: 'The Evolution of Mainframe Solutions & BuildFit AI',
    description: 'Discussed the evolution of Mainframe Solutions and BuildFit AI, focusing on workforce infrastructure, operational systems, AI governance, and building scalable hiring and operational frameworks for modern organizations.',
  },
];

export const insights = [
  {
    id: 1,
    category: 'AI Governance',
    title: 'Why AI Assisted Hiring Requires Human Oversight',
    excerpt: 'The most effective AI hiring tools augment human decision-making rather than replacing it. Here is why governance frameworks matter.',
    date: 'March 2025',
    readTime: '5 min read',
  },
  {
    id: 2,
    category: 'Workforce Strategy',
    title: 'Building Operational Infrastructure That Scales',
    excerpt: 'Organizations that invest in structured hiring and operational systems see measurable improvements in efficiency and revenue generation.',
    date: 'January 2025',
    readTime: '7 min read',
  },
  {
    id: 3,
    category: 'Executive Search',
    title: 'The Economics of a Bad Hire',
    excerpt: 'Quantifying the true cost of misaligned executive placements and how structured evaluation frameworks reduce organizational risk.',
    date: 'November 2024',
    readTime: '4 min read',
  },
];

export const trustBadges = [
  { label: 'Executive Search', icon: 'ri-briefcase-line' },
  { label: 'AI Governance', icon: 'ri-shield-check-line' },
  { label: 'Structured Hiring', icon: 'ri-user-search-line' },
  { label: 'Software Development', icon: 'ri-code-box-line' },
  { label: 'Operational Systems', icon: 'ri-settings-6-line' },
];